import styles from "./UserPanel.module.css";
import { observer } from "mobx-react-lite";
import { userStore } from "@/stores/UserStore";
import { userPanelSettingStore } from "@/stores/UserPanelSettingStore";

//icons
import Close from "@/assets/icons/common/close.svg?react";
import { Body } from "./Body";
import { authStore } from "@/stores/AuthStore";
import { OverlayForNodeContent } from "../OverlayForNodeContent/OverlayForNodeContent";
import { WaitingUtils } from "@/stores/WaitingUtils";

export const UserPanel = observer(() => {
  const { modal } = userPanelSettingStore;
  const { roleName } = userStore;

  return (
    modal.openModal && (
      <OverlayForNodeContent
        style={{
          padding: "0px",
          width: "80%",
          minWidth: "1000px",
          height: "600px",
          maxHeight: "90vh",
        }}
        modalData={modal}
        utilsData={new WaitingUtils()}
      >
        <div className={styles.borderPanel}>
          <div className={styles.top}>
            <div className={styles.topLeft}>
              <button
                disabled={!userStore.isAuthenticated}
                className={styles.logout}
                onClick={() => {
                  authStore.logout();
                  modal.isHide();
                }}
              >
                Выйти из учетной записи
              </button>
              <span>{userStore.login}</span>
              <p>{`- ${roleName}`}</p>
            </div>
            <div className={styles.close} onClick={() => modal.isHide()}>
              <Close />
            </div>
          </div>
          <Body />
        </div>
      </OverlayForNodeContent>
    )
  );
});
